<script setup>
const { $auth } = useNuxtApp()
const userListStore = useUserList()
const { isLoading } = storeToRefs(useLayout())

$auth.requireLogin()

// Refs
const showListForm = ref(false)

// Methods
const startSpinner = () => {
  isLoading.value = true
}

const stopSpinner = () => {
  isLoading.value = false
}

const onSave = async (formData) => {
  startSpinner()
  try {
    await userListStore.createList(
      formData.value.name,
      formData.value.creator,
      formData.value.description,
    )
  } finally {
    stopSpinner()
  }
}

// Fetch data
const fetchData = async () => {
  startSpinner()
  try {
    if (!$auth.loggedIn) return
    await userListStore.fetchMyLists()
  } catch (e) {
    console.error(e)
  } finally {
    stopSpinner()
  }
}

// Watchers
watch(() => $auth.loggedIn, fetchData)

onActivated(() => {
  stopSpinner()
  fetchData()
})
</script>

<template>
  <section class="account-cellar list-lists-page">
    <CellarHeader
      active-link="lists"
      :class="{ 'creating-list': showListForm }"
    />

    <div class="site-width site-width-full">
      <div class="account-cellar--user-lists active">
        <div
          :class="{
            'account-cellar--user-list-container': true,
            'creating-list': showListForm,
          }"
        >
          <div class="new-lists small-12 medium-5 large-4">
            <div
              v-if="!showListForm"
              class="new-list-button"
              @click="showListForm = true"
            >
              <span class="icon-red-add"></span>
              New List
            </div>
            <div v-if="!showListForm" class="list-placeholder">
              <div class="create-list-icon">
                <img src="~/assets/images/club-hand-bottom-gray.svg" />
              </div>
              <div class="create-list-cta">
                Build your wine lists,<br />
                share with friends.
              </div>
            </div>
            <UserListForm
              v-if="showListForm"
              :on-save="onSave"
              @closed="showListForm = false"
            />
          </div>
          <div class="existing-lists small-12 medium-7 large-8">
            <ul v-if="userListStore.myLists.length" class="list-rows">
              <li v-for="list in userListStore.myLists" :key="list.id">
                <NuxtLink
                  :to="`/cellar/lists/${list.id}/`"
                  class="list-row"
                  aria-label="Open list"
                >
                  <span
                    class="icon-share"
                    aria-hidden="true"
                    @click.prevent="userListStore.shareList(list)"
                  ></span>
                  <span class="name">{{ list.name }}</span>
                </NuxtLink>
              </li>
            </ul>
          </div>
          <ShareListModal
            :show-share-modal="userListStore.showShareModal"
            @closed="userListStore.showShareModal = false"
          ></ShareListModal>
        </div>
      </div>
    </div>
  </section>
</template>
